import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const projects = [
  {
    title: "Provus Case Study",
    href: "https://www.behance.net/gallery/185244525/Provus-Case-study",
    image:
      "https://mir-s3-cdn-cf.behance.net/projects/404/cd2a39185244525.Y3JvcCwzNzY4LDI5NDgsOTk4LDA.jpg",
    tag: "Enterprise · UX",
    views: 56,
    likes: 0,
  },
  {
    title: "Animal Rescue",
    href: "https://www.behance.net/gallery/153747649/Animal-Rescue",
    image:
      "https://mir-s3-cdn-cf.behance.net/projects/404/e27f30153747649.Y3JvcCwzOTU4LDMwOTYsNTc4LDA.png",
    tag: "Social Impact · App",
    views: 61,
    likes: 0,
  },
  {
    title: "Traffic Management",
    href: "https://www.behance.net/gallery/152304477/Traffic-Management",
    image:
      "https://mir-s3-cdn-cf.behance.net/projects/404/061588152304477.Y3JvcCw0MzI2LDMzODQsODU2LDA.png",
    tag: "Civic Tech · UX",
    views: 92,
    likes: 2,
  },
  {
    title: "Admission App",
    href: "https://www.behance.net/gallery/150515563/Admission-app",
    image:
      "https://mir-s3-cdn-cf.behance.net/projects/404/503d40150515563.Y3JvcCw2MDQ4LDQ3MzAsMCwyNTAw.png",
    tag: "Education · Mobile",
    views: 70,
    likes: 1,
  },
  {
    title: "Laundry Service",
    href: "https://www.behance.net/gallery/149876249/Laundry-Service",
    image:
      "https://mir-s3-cdn-cf.behance.net/projects/404/8109f0149876249.Y3JvcCw1MDIxLDM5MjgsNTA5LDA.png",
    tag: "Service · Mobile",
    views: 234,
    likes: 4,
  },
];

const cardVariant = {
  hidden: { opacity: 0, y: 20 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.65, 0, 0.35, 1], delay: i * 0.07 },
  }),
};

export const AllProjects = () => {
  return (
    <section
      id="archive"
      data-testid="all-projects-section"
      className="relative border-t border-black/10 py-24 md:py-32 lg:py-40 bg-[#F4F4F2]"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="grid grid-cols-12 gap-6 md:gap-12 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-3">
            <div className="font-mono-mini text-[#8A8A8A]">§ 02</div>
            <div className="font-mono-mini text-[#0A0A0A] mt-1">All Projects</div>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-5">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.65, 0, 0.35, 1] }}
              className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[1.05]"
            >
              A wider archive — student briefs, side projects and early
              explorations, all lived on Behance.
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-3 md:col-start-11 flex md:items-end md:justify-end">
            <a
              href="https://www.behance.net/MrinmoyPapai"
              target="_blank"
              rel="noreferrer"
              data-testid="all-projects-behance-link"
              className="group inline-flex items-center gap-2 font-mono-mini text-[#0A0A0A]"
            >
              <span className="link-underline-static">View on Behance</span>
              <ArrowUpRight
                size={14}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </a>
          </div>
        </div>

        {/* Archive grid — dense ledger style */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-12 md:gap-y-16 border-t border-black/15 pt-10 md:pt-14">
          {projects.map((p, i) => (
            <motion.a
              key={p.title}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`archive-project-${i}`}
              variants={cardVariant}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="group block"
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-[#EFEEEC]">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-x-3 top-3 flex items-center justify-between font-mono-mini text-white mix-blend-difference">
                  <span>{String(i + 1).padStart(2, "0")}</span>
                  <ArrowUpRight
                    size={14}
                    className="opacity-70 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </div>
              </div>
              <div className="mt-4 flex items-baseline justify-between gap-3">
                <h3 className="font-display text-lg md:text-xl tracking-tighter leading-tight">
                  {p.title}
                </h3>
              </div>
              <div className="mt-1 flex items-center justify-between font-mono-mini text-[#8A8A8A]">
                <span>{p.tag}</span>
                <span>
                  {p.views}v · {p.likes}♥
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
